module.exports = __webpack_public_path__ + "img/image (16).6b71a587.png";